export default __webpack_public_path__ + "static/media/analisisS.a9fc8fb0.png";